<template>
    <div class="channel-card">
        <div class="channel-icon-wrapper">
            <img
                v-if="getChannelLogo(channel.type)"
                :src="getChannelLogo(channel.type)"
                :alt="channel.type"
                class="channel-icon-img"
            />
            <div
                v-else
                class="channel-icon"
                :class="getChannelIconClass(channel.type)"
            >
                <span v-if="channel.type === 'YCLIENTS'">YC</span>
                <span v-else-if="channel.type === 'MAX'">M</span>
                <span v-else>{{ channel.type.charAt(0) }}</span>
            </div>
        </div>
        <div class="channel-info">
            <div class="channel-name">{{ channel.name || channel.type }}</div>
            <div v-if="channel.phone" class="channel-phone">{{ channel.phone }}</div>
        </div>
        <div class="channel-actions">
            <span v-if="isConnected" class="status-connected">подключен</span>
            <v-btn
                v-else
                small
                outlined
                color="mainNew"
                @click="$emit('connect', channel)"
            >
                подключить
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChannelCard',
    props: {
        channel: {
            type: Object,
            required: true,
        },
        connectedChannels: {
            type: Array,
            default: () => [],
        },
        showCheckbox: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isConnected() {
            if (this.channel.connected !== undefined) {
                return this.channel.connected
            }
            const connected = this.connectedChannels.find(ch => ch.id === this.channel.id)
            return connected?.connected || false
        },
    },
    methods: {
        getChannelLogo(type) {
            const logoMap = {
                MAX: require('@/assets/img/messenger-logo/max-logo.png'),
                Telegram: require('@/assets/img/messenger-logo/telegram-logo.png'),
                WhatsApp: require('@/assets/img/messenger-logo/wa-logo.png'),
                YCLIENTS: null, // Используем fallback с иконкой
            }
            return logoMap[type] !== undefined ? logoMap[type] : null
        },
        getChannelIconClass(type) {
            const classMap = {
                YCLIENTS: 'channel-icon-yclients',
                MAX: 'channel-icon-max',
                Telegram: 'channel-icon-telegram',
                WhatsApp: 'channel-icon-whatsapp',
            }
            return classMap[type] || 'channel-icon-default'
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.channel-card
    display: flex
    align-items: center
    gap: 12px
    padding: 12px
    border: 1px solid #E0E0E0
    border-radius: 8px
    flex: 1
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    cursor: grab
    &:active
        cursor: grabbing

.channel-icon-wrapper
    width: 32px
    height: 32px
    flex-shrink: 0
    display: flex
    align-items: center
    justify-content: center

.channel-icon-img
    width: 32px
    height: 32px
    object-fit: contain

.channel-icon
    width: 32px
    height: 32px
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    color: white
    font-weight: bold
    font-size: 12px

.channel-icon-yclients
    background: #FFC107

.channel-icon-max
    background: #9C27B0

.channel-icon-telegram
    background: #2196F3

.channel-icon-whatsapp
    background: #25D366

.channel-icon-default
    background: #7F8997

.channel-info
    flex: 1
    min-width: 0

.channel-name
    font-size: 14px
    font-weight: 500
    color: #2A3B51
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

.channel-phone
    font-size: 12px
    color: #7F8997
    margin-top: 2px

.channel-actions
    flex-shrink: 0

.status-connected
    color: #4CAF50
    font-size: 12px
</style>
